import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=294cd4f2&scoped=true&"
import script from "./Ecosystem.vue?vue&type=script&lang=js&"
export * from "./Ecosystem.vue?vue&type=script&lang=js&"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=294cd4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294cd4f2",
  null
  
)

export default component.exports